import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';
import {
	toggleFilterSections,
	getFilterLevels,
	setFilterLevel,
	resetFilterSelectedTopics,
	resetFilterSelectedSubjects,
	resetFilterSelectedClasses,
} from '../../../../redux/actions';
import { Dropdown } from '../../../../components';

function Levels() {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getFilterLevels());
	}, [dispatch]);

	return (
		<Dropdown
			className="level-dropdown"
			title={'Poziom nauczania'}
			name="levels"
			isOpen={state.filter.activeSections.indexOf('levels') !== -1}
			onClick={() => {
				dispatch(toggleFilterSections('levels'));
			}}
			selected={
				state.filter.levels.length > 0 &&
				state.filter.selected.level &&
				state.filter.levels.find((level) => level.id === state.filter.selected.level).poziom
			}
		>
			<ul className="dropdown-list" onClick={() => {}}>
				{state.filter.levels.length > 0 ? (
					state.filter.levels.map((level) => (
						<li
							className={`dropdown-list-item${
								state.filter.selected.level === level.id ? ' selected' : ''
							}`}
							key={level.id}
							onClick={() => {
								dispatch(setFilterLevel(level.id));
								dispatch(toggleFilterSections('levels'));
								if (!state.filter.activeSections.includes('classes')) {
									dispatch(toggleFilterSections('classes'));
								}
								dispatch(resetFilterSelectedClasses());
								dispatch(resetFilterSelectedSubjects());
								dispatch(resetFilterSelectedTopics());
							}}
						>
							{level.poziom}
						</li>
					))
				) : (
					<li className="dropdown-list-item" key={'brak'}>
						Brak
					</li>
				)}
			</ul>
		</Dropdown>
	);
}

export default Levels;
